import React from 'react'
import './UserTextArea.css'

const UserTextArea = ({name, required, placeholder, className, value, onChange, ...props}) => {
    return (
        <textarea
            name={name ? name : ''}
            required={required ? required : false}
            autoComplete='off'
            placeholder={placeholder ? placeholder : ''}
            className={`userTextArea ${className || ''}`}
            onChange={onChange}
            value={value ? value : ''}
            {...props}
        />
    )
}

export default UserTextArea
